import axios from 'axios';
import router from '../router';
import {Dialog, Toast} from "vant";
import {BASE_URL} from "@/common/config";

// 正式打包时使用
export let baseURL = BASE_URL;

// 开发时使用
if (process.env.NODE_ENV === 'development') {
    baseURL = '/';
}

const instance = axios.create({
    baseURL,
});

instance.interceptors.request.use(
    (config) => {
        config.withCredentials = true;
        if (!config.url.includes('/Expedite/')) {
            // 设置登录token
            const token = localStorage.getItem('token') || '';
            config.headers['Authorization'] = `${token}`;
            // config.headers['Referer'] = ``;
        }
        return config;
    },
    (error) => {
        throw Promise.reject(error);
    },
);
/**
 *
 * @param code 状态码：
 *   200 请求成功
 *   400 参数错误
 *   401 用户未登陆
 *   403 用户无权限
 *   404 接口不存在
 *   500 请求错误
 * @param data
 * @param response
 * @returns {*}
 */
const  responseFilter = (code = -1, data = { }, response) => {
    console.debug(data);
    let msg = '系统错误';
    switch(code){
        case 1:
        case 201:
        case 200: return data;
        case 400:
            Toast.fail(data.msg);
            break;
        case -1:
        case 401:
        case 403:
            if (response.config.notShowLoginWindow) {
                throw Promise.reject({ msg: '请登录后操作！', data });
            }
            return Dialog.confirm({
                title: '提示',
                message: '请登录后操作！',
                confirmButtonText: '去登录',
            }).then(() => {
                localStorage.clear();
                router.push('/login');
            });
        case 0:
        case 404:
        case 500:
            msg = data.msg || msg;
            Toast.fail(msg);
            break;
    }
    throw Promise.reject({ msg, data });
};

instance.interceptors.response.use(
    (res) => {
        switch(res.status){
            case 201:
            case 200: return responseFilter(res.data.code, res.data, res);
            default:
                Toast.fail('系统错误');
                throw Promise.reject(res.data);
        }
    },
    (error) => responseFilter((error.response || {}).status || 0, error.response, error.response),
);

export const request = {
    get: (url, params, config) => instance.get(url, { params, ...config }),
    post: (url, params, config) => instance.post(url, params, config),
    postQS: (url, params) => instance.post(url, {}, {params}),
    postForm: (url, params) => instance.post(url, params, {
        transformRequest: [function(data) {
            let ret = ''
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret;
        }],
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
    }),
};
